/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

const MUTATIONS = {
  Program: require('../queries/FinalizeProgram.gql'),
  Standard: require('../queries/ScopeStandard.gql'),
  Section: require('../queries/ScopeSection.gql'),
  Objective: require('../queries/ScopeObjective.gql'),
};

export default {
  methods: {
    /**
     * Mutates status of an object, supporting mutations from `MUTATIONS`
     * @param newStatus the status to set. Make sure it is available for the `type`!
     * @param id is the object id (e.g. `Program:3`)
     * @param type is the type of the object (e.g. `Program`). Must be defined in `MUTATIONS`.
     */
    setStatus(newStatus: String, id: String, type: string) {
      const variables = {
        status: newStatus,
        id: id,
      };

      const mutation = MUTATIONS[type];
      return this.$apollo.mutate({ mutation, variables });
    },
  },
};
